import React from "react";

import { Plus } from "shared/assets/icons";
import { IconButton } from "shared/components";
import { MutedText, TinyText } from "shared/styles";

import { StyledMenuToggle } from "./styles";

import { copy } from "shared/assets";
import { ITheme } from "shared/types";
const { menu: menuCopy } = copy;

interface MenuToggleProps {
  isOpen?: boolean;
}

export const MenuToggle: React.FC<MenuToggleProps> = ({ isOpen }) => (
  <StyledMenuToggle>
    <TinyText as={MutedText}>
      {isOpen ? menuCopy.close : menuCopy.open}
    </TinyText>
    <IconButton
      icon={Plus}
      iconTransform={isOpen ? "rotate(45deg)" : "none"}
      label={isOpen ? menuCopy.close : menuCopy.open}
      theme={ITheme.primary}
    />
  </StyledMenuToggle>
);
